import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { Button, FormGroup, Label, Row, Col } from "reactstrap";
import { Formik, ErrorMessage } from "formik";
import { cloneDeep } from "lodash";
import { default as ReactSelect } from "react-select";
import { Option, LimitedChipsContainer } from "components/Options";
import FormikSelectField from "components/common/Fields/FormikSelectField";
import useAxios from "hooks/useAxios";
import * as Yup from "yup";
import ThirdPartyAdmin from "components/ThirdPartyAdmin";
import useContextService from "hooks/useContextService";
import CoveredEntity from "components/CoveredEntity";
import Pharmacy from "components/Pharmacy";
import reset from "assets/icon/reset.svg";
import searchicon from "assets/icon/search.svg";
// import Add from 'assets/icon/Add-White-Icon.svg'
import plus from "assets/icon/plus-icon.svg";
import AddContractModal from "../AddContract";
import { ModuleAccess } from "utils/moduleaccess";
const validationSchema = Yup.object({
  thirdPartyAdminID: Yup.string().required(
    "Third party Administrator is required"
  ),
});

let ceData = [];
let pharmacyData = [];
const SearchContracts = (props) => {
  const API = useAxios();
  const {
    states: { contracts },
    setStates,
    resetStates,
  } = useContextService();
  const { onSearch, onReset,    refetch,
 } = props;
  const [ceDatalist, setCeDatalist] = useState([]);
  const [selectedOption, setOptionSelected] = useState({
    optionSelected: "-1",
  });
  const [selectedOpt, setOptSelected] = useState({ optSelected: "-1" });
  const [isSubmitting, setSubmitting] = useState(true);
  const [CEName, setCEName] = useState("");
  const formikRef = useRef();
  const {
    thirdPartyAdmin,
    pharmacies,
    coveredEntities,
    searchTerms,
    coveredEntity,
    pharmacy,
        enableAdd
  } = contracts;
  const { thirdPartyAdminID, coveredEntityID, pharmacyID, ceIds } = searchTerms;
  const { tenantID } = thirdPartyAdmin;

  const updateStates = (contracts) => {
    setStates("contracts", contracts);
  };

  useEffect(() => {
    contracts.thirdPartyAdmin = {};
    contracts.pharmacies = [];
    contracts.coveredEntities = [];
    contracts.coveredEntity = "";
    contracts.pharmacy = "";
    onReset();
    setOptionSelected({ optionSelected: "-1" });
    contracts.searchTerms.ceIds = {};
    setCeDatalist([]);
    contracts.searchTerms.pharmacyids = {};
    pharmacyData = [];
    ceData = [];
    setOptSelected({ optSelected: "-1" });
    resetStates("contracts");
  }, []);

  // const handleSubmit = async (val, actions) => {
  //   //const { setSubmitting } = actions;
  //   const values = cloneDeep(val);
  //   if (pharmacyID) values.pharmacyID = pharmacyID;
  //   if (coveredEntityID) values.coveredEntityID = coveredEntityID;
  //   contracts.search.currentPage = 1;
  //   updateStates(contracts);
  //   await onSearch(values);
  //   setSubmitting(false);
  // };

  const handleSubmit = async (val, actions) => {
    let coveredEntityIDS = [];
    for (var x in selectedOption.optionSelected) {
      var rw = selectedOption.optionSelected[x];
      coveredEntityIDS.push(rw.value);
    }
    let pharmacyIDs = [];
    for (var x in selectedOpt.optSelected) {
      var rw = selectedOpt.optSelected[x];
      pharmacyIDs.push(rw.value);
    }
    const { setSubmitting } = actions;
    const values = cloneDeep(val);
    if (thirdPartyAdminID) values.thirdPartyAdminID;
    // if(coveredEntityID) values.coveredEntityID=coveredEntityID;
    // if (pharmacyID) values.pharmacyID = pharmacyID;
    if (pharmacyIDs > [0]) values.pharmacyIDs = pharmacyIDs;
    if (coveredEntityIDS > [0]) values.coveredEntityIDS = coveredEntityIDS;
    contracts.search.currentPage = 1;
    updateStates(contracts);
    await onSearch(values);
    setSubmitting(false);
  };

  const fetchCoveredEntities = async (thirdPartyAdminID) => {
    setCeDatalist([]);
    ceData = [];
    try {
      const { data } = await API.get(
        `GWConfig/coveredentity/CElist/${thirdPartyAdminID}`,
        {
          hasDefaultURL: true,
          hideLoader: true,
        }
      );
      if (data) {
        for (var x in data) {
          ceData.push({ value: data[x].id, label: data[x].description });
        }
        setCeDatalist(ceData);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleCEChange = (selected) => {
    if (selected.length !== 0) {
      setOptSelected({
        optSelected: -1,
      });
    }
    if (selected.length === 0) {
      fetchPharmacyNamesByTpaID(thirdPartyAdminID);
    }
    pharmacyData = [];
    setOptionSelected({
      optionSelected: selected,
    });
    contracts.searchTerms.ceIds = selected;
    updateStates(contracts);
    fetchPharmacyNames(selected);
  };

  const fetchPharmacyNamesByTpaID = async (thirdPartyAdminID) => {
    pharmacyData = [];
    try {
      const { data } = await API.get(
        `GWConfig/coveredentity/GetPharmaciesByTpaId/${thirdPartyAdminID}`,
        {
          hasDefaultURL: true,
          hideLoader: true,
        }
      );
      if (data) {
        for (var x in data) {
          if (!pharmacyData.some(item => item.value === data[x].pharmacyID)) {
            pharmacyData.push({
              value: data[x].pharmacyID,
              label: data[x].pharmacyName,
            });
          }
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const fetchPharmacyNames = async (selected) => {
    let payloads = [];
    pharmacyData = [];
    for (var x in selected) {
      var rw = selected[x];
      payloads.push(rw.value);
    }
    let payload = {};
    payload.CoveredIDS = payloads;
    try {
      const { data } = await API.post(
        `GWConfig/coveredentity/Pharmacieslist/${thirdPartyAdminID}`,
        payload,
        {
          hasDefaultURL: true,
          hideLoader: true,
        }
      );
      console.log(data);
      if (data) {
        for (var x in data) {
          if (!pharmacyData.some(item => item.value === data[x].pharmacyID)) {
            pharmacyData.push({
              value: data[x].pharmacyID,
              label: data[x].pharmacyName,
            });
          }
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleThirdPartyAdminChange = async (value, setFieldValue, tpa) => {
    pharmacyData = [];
    ceData = [];
    setOptionSelected({ optionSelected: "-1" });
    contracts.searchTerms.ceIds = {};
    setCeDatalist([]);
    contracts.searchTerms.pharmacyids = {};
    setOptSelected({ optSelected: "-1" });

    const { thirdPartyAdminID } = tpa;
    fetchCoveredEntities(thirdPartyAdminID);
    fetchPharmacyNamesByTpaID(thirdPartyAdminID);
    if (tpa) {
      const { thirdPartyAdminID } = tpa;
      setFieldValue("thirdPartyAdminID", value);
      contracts.coveredEntity = "";
      contracts.searchTerms.coveredEntityID = "";
      contracts.pharmacy = "";
      contracts.searchTerms.pharmacyID = "";
      contracts.thirdPartyAdmin = tpa;
      contracts.searchTerms.thirdPartyAdminID = thirdPartyAdminID;
    } else {
      setFieldValue("thirdPartyAdminID", "");
      contracts.coveredEntity = "";
      contracts.searchTerms.coveredEntityID = "";
      contracts.pharmacy = "";
      contracts.searchTerms.pharmacyID = "";
      contracts.thirdPartyAdmin = {};
      contracts.searchTerms.thirdPartyAdminID = "";
      pharmacyData = [];
      ceData = [];
    }
    updateStates(contracts);
  };

  const handlepharmacyChange = (selected) => {
    setOptSelected({
      optSelected: selected,
    });
    contracts.searchTerms.pharmacyids = selected;
    updateStates(contracts);
  };

  // const handleCEChange= async (setFieldValue,value) => {
  //   if (value) {
  //     setFieldValue('coveredEntityID', value.id);
  //     contracts.coveredEntity = value;
  //     contracts.searchTerms.coveredEntityID = value.id;
  //     contracts.pharmacy = '';
  //     contracts.searchTerms.pharmacyID = '';
  //   } else {
  //     contracts.coveredEntity = '';
  //     contracts.searchTerms.coveredEntityID = '';
  //     setFieldValue('coveredEntityID', '');
  //   }
  //   updateStates(contracts);
  // };

  const handlePHChange = async (setFieldValue, pharmacy) => {
    if (pharmacy) {
      contracts.pharmacy = pharmacy;
      contracts.searchTerms.pharmacyID = pharmacy.id;
      setFieldValue("pharmacyID", pharmacy.id);
    } else {
      contracts.pharmacy = "";
      contracts.searchTerms.pharmacyID = "";
      setFieldValue("pharmacyID", "");
    }
    updateStates(contracts);
  };

  const handleReset = ({ resetForm }) => {
    resetForm();
    onReset();
    resetStates("contracts");
    setOptionSelected({ optionSelected: "-1" });
    contracts.searchTerms.ceIds = {};
    setCeDatalist([]);
    contracts.searchTerms.pharmacyids = {};
    pharmacyData = [];
    ceData = [];
    setOptSelected({ optSelected: "-1" });
  };

  useEffect(() => {
    pharmacyData = [];
  }, [])
  
 const [addState, updateAddState] = useState({
    addContractModal: false,
  });
    const setState = (obj) => updateAddState((pre) => ({ ...pre, ...obj }));

    const onToggleAddContractModal = () => {
    // refetch();
    setState({
      addContractModal: !addState.addContractModal,
    });
  };
    const { addContractModal } = addState;
  const hasPermission = (code) => {
    return ModuleAccess("CON", code);

  }
  return (
    <Formik
      innerRef={formikRef}
      initialValues={searchTerms}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
      enableReinitialize={true}
      children={(props) => {
        const {
          isSubmitting,
          handleSubmit,
          resetForm,
          setFieldValue,
          errors,
          touched,
        } = props;
        return (
          <>
          <div className="d-flex justify-content-between">
            <h5 className="f-15 text-primary font-weight-700">Search Contracts</h5>
              <Button onClick={onToggleAddContractModal} disabled={!thirdPartyAdminID} color='primary' className='reset' size='sm' hidden={!hasPermission('ADD')} >
                      <span className="right_5">
                        <img src={plus} alt="" />
                      </span>{" "}
            
                      Add
                    </Button>
                      </div>
            <Row>
              <Col md={3} sm={3} xs={3}>
                {" "}
                <FormGroup>
                  <Label for="tpa">Third Party Administrator</Label>
                  <ThirdPartyAdmin
                    value={thirdPartyAdminID}
                    name="thirdPartyAdminID"
                    onChange={(value, tpa) =>
                      handleThirdPartyAdminChange(value, setFieldValue, tpa)
                    }
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={3} xs={3}>

                <FormGroup>
                  <Label for="coveredEntity">Covered Entity</Label>
                  {/* // <CoveredEntity
                  thirdPartyAdminID={thirdPartyAdminID||''}
                  onSelect={(value)=>handleCEChange(setFieldValue,value)}
                  selectedCE={coveredEntity} 
                  /> */}

                  <ReactSelect
                    name="ceDatalist"
                    options={ceDatalist}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    optionSelected={true}
                    components={{
                      Option,
                      ValueContainer: LimitedChipsContainer,
                    }}
                    isSearchable="true"
                    onChange={handleCEChange}
                    value={selectedOption.optionSelected}
                    className="claim_info"
                    maxMenuHeight={220}
                    styles={{
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 99,
                      }),
                      option : (provided) => ({
                        ...provided,
                        display: 'flex',
                        alignItems: 'flex-start',
                      })
                    }}
                  />

                </FormGroup>
              </Col>
              <Col md={3} sm={3} xs={3} className="covered-entity-input">
                <FormGroup>
                  <Label for="pharmacy">Pharmacy</Label>
                  {/* <Pharmacy
                  thirdPartyAdminID={thirdPartyAdminID}
                  coveredEntityID={coveredEntityID}
                  onSelect={(value)=>handlePHChange(setFieldValue,value)}
                  selectedPH={pharmacy}
                  /> */}

                  <ReactSelect
                    name="pharmacyData"
                    options={pharmacyData}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    optionSelected={true}
                    components={{
                      Option,
                      ValueContainer: LimitedChipsContainer,
                    }}
                    isSearchable="true"
                    onChange={handlepharmacyChange}
                    value={selectedOpt.optSelected}
                    className="claim_info"
                    maxMenuHeight={220}
                    styles={{
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 99,
                      }),
                      option : (provided) => ({
                        ...provided,
                        display: 'flex',
                        alignItems: 'flex-start',
                      })
                    }}
                  />
                </FormGroup>
              </Col>{" "}
              </Row>
               <Row className="d-flex justify-content-end">
              <Col md="auto" className="pt-4 mt-1">
                <Label>{""}</Label>
                <Button
                  disabled={isSubmitting}
                  onClick={handleSubmit}
                  color="primary"
                  className="search ms-3"
                >
                  <span className="right_5">
                    <img src={searchicon} alt="" />
                  </span>{" "}
                  Search
                </Button>
                <Button color="primary" className="reset" onClick={() => handleReset(props)}>
                  <span className="right_5">
                    <img src={reset} alt="" />
                  </span>{" "}
                  Reset
                </Button>
              </Col>
            </Row>
              <AddContractModal isOpen={addContractModal} thirdPartyAdmin={thirdPartyAdmin} toggle={onToggleAddContractModal} />
        
          </>
        );
      }}
    ></Formik>
  );
};

export default SearchContracts;
